/* Compact entry points to the existing stock notification form. */
if (!customElements.get('ayaq-pdp-restock')) {
  customElements.define(
    'ayaq-pdp-restock',
    class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new window.AbortController();
        const { signal } = this.controller;
        const initialize = () => {
          this.section = this.closest('.ayaq-pdp');
          this.opener = this.querySelector('.restock-opener');
          this.modal = document.querySelector('#restock-notify-modal');
          if (!this.section || !this.opener || !this.modal) return;
          this.buttons = Array.from(
            this.section.querySelectorAll('[data-pdp-restock-size]'),
          );
          if (!this.buttons.length) return;
          this.hidden = true;
          this.section.addEventListener(
            'click',
            (event) => {
              const button = event.target.closest('[data-pdp-restock-size]');
              if (!button || button.hidden) return;
              event.preventDefault();
              event.stopPropagation();
              this.open(button);
            },
            { signal },
          );
          this.observer = new MutationObserver(() => this.sync());
          this.section
            .querySelectorAll('.ayaq-pdp__size-options')
            .forEach((group) => {
              this.observer.observe(group, {
                subtree: true,
                attributes: true,
                attributeFilter: ['class', 'disabled', 'hidden', 'style'],
              });
            });
          this.modalObserver = new MutationObserver(() => {
            if (!this.modal.hasAttribute('open') && this.activeButton) {
              this.activeButton = null;
              this.modal.hide();
            }
          });
          this.modalObserver.observe(this.modal, {
            attributes: true,
            attributeFilter: ['open'],
          });
          this.sync();
        };
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', initialize, {
            once: true,
            signal,
          });
        } else initialize();
      }

      sync() {
        this.buttons.forEach((button) => {
          const choice = button.closest('.ayaq-pdp__size-choice');
          const input = choice.querySelector('input');
          const label = choice.querySelector('label');
          const unavailable =
            label.classList.contains('unavailable_label') ||
            label.classList.contains('unavailable_label_selected');
          const show =
            unavailable &&
            !input.hidden &&
            !label.hidden &&
            label.style.display !== 'none';
          if (button.hidden === show) button.hidden = !show;
          if (show) input.tabIndex = -1;
          else input.removeAttribute('tabindex');
        });
      }

      open(button, focusTarget = button) {
        this.opener.click();
        if (!this.modal.hasAttribute('open')) return;
        const size = Array.from(
          this.modal.querySelectorAll('.restock-size'),
        ).find(
          (item) => item.textContent.trim() === button.dataset.pdpRestockSize,
        );
        if (size && size.getAttribute('aria-pressed') !== 'true') size.click();
        this.activeButton = button;
        this.modal.show(focusTarget);
        this.modal
          .querySelector('#restock-email')
          ?.focus({ preventScroll: true });
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
        this.modalObserver?.disconnect();
      }
    },
  );
}
